<template>
  <div class="c-modal-container">
    <div class="card">
      <div :class="`card-content pb-${negativeLabel ? 3 : 5}`">
        <form @submit.prevent="onSubmit">
          <span class="title is-5" v-html="title"></span>
          <hr class="my-3" />

          <component
            v-if="isActive"
            v-bind="props"
            :is="component"
            @setOnSubmit="setOnSubmit"
          ></component>

          <hr class="mb-3" />
          <div
            class="columns is-desktop is-variable is-1 is-flex-direction-row-reverse-desktop"
          >
            <div class="column is-full-touch is-one-third-desktop">
              <b-button
                class="mb-1"
                :type="type"
                native-type="submit"
                expanded
              >
                {{ positiveLabel }}
              </b-button>
            </div>
            <div class="column is-full-touch is-one-quarter-desktop">
              <b-button
                type="is-white"
                @click="$parent.close"
                v-if="negativeLabel"
                expanded
              >
                {{ negativeLabel }}
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CFormPopup",
  data() {
    return {
      isActive: false,
      onSubmit: ""
    };
  },
  props: {
    title: String,
    positiveLabel: String,
    negativeLabel: String,
    component: Object,
    props: Object,
    type: {
      type: String,
      default: "is-primary"
    }
  },
  methods: {
    submit(...props) {
      this.$emit("onSubmit", ...props);
      this.$parent.close();
    },
    setOnSubmit(callback) {
      this.onSubmit = () => callback(this.submit);
    }
  },
  mounted() {
    this.isActive = true;
  }
};
</script>

<style lang="scss" scoped>
.c-modal-container {
  max-width: 440px;
  margin-left: auto !important;
  margin-right: auto !important;
}

.c-modal-container .card {
  margin-left: 1rem;
  margin-right: 1rem;
  border-radius: 0.5rem;
}

@media screen and (max-width: 1023px) {
  .c-modal-container .columns .column:first-child {
    padding-bottom: 0;
  }

  .c-modal-container .columns .column:last-child {
    padding-top: 0;
  }
}

@media screen and (min-width: 1024px) {
  .is-flex-direction-row-reverse-desktop {
    flex-direction: row-reverse;
  }
}

</style>
